<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-8">
                    <card>
                        
                        <form>
                            <div class="row">
                                <div class="col-md-11">
                                    <h4 slot="header" class="card-title">Plant Photo - {{data.botanical_name}}</h4>
                                </div>
                                
                                <div class="col-md-1">
                                    <div class="form-group">
                                        <button type="submit" class="btn btn-success btn-fill "
                                            @click.prevent="save">Save
                                        </button>

                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-4">
                                    <card>
                                        <h4 slot="header" class="card-title">Preview Image</h4>
                                        <span v-if="data.preview_img">
                                            <img class="p-photo" v-bind:src="data.preview_img"/>
                                        </span>
                                        <div>
                                            <input ref="beforeFileInput" class="btn-file" type="file" @change="uploadFile($event)">
                                            <button type="submit" class="btn btn-info btn-fill"
                                                    @click.prevent="$refs.beforeFileInput.click()">
                                                
                                                {{data.preview_img ? 'Upload new' : 'Upload'}}
                                            </button>
                                            <div class="clearfix"></div>
                                        </div>
                                    </card>
                                </div>
                            </div>
                            
                            <div class="row images-row">
                                <div 
                                    v-for="(image, image_index) in data.photos" 
                                    v-bind:key="'image' + image_index"
                                    @click.prevent="removePhotoImageItem(image_index)" 
                                    class="col-md-2 img-item">
                                        <img alt="Remove" class="images-col" v-bind:src="data.photos[image_index].url"/>
                                </div>
                                
                            </div>  
                                   

                                   

                                   

                        </form>
                    </card>
                </div>


            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import Card from 'src/components/UIComponents/Cards/Card.vue';

    export default {
        components: {
            Card,
        },
        data() {
            return {
                data: {

                },

                id: 0,
                token: localStorage.getItem('token'),
                array_fields: [
                        'common_names',
                        'bloom_time',
                        'flower_color',
                        'hardiness_zone',
                        'soil_type',
                        'soil_ph',
                        'soil_drainage',
                        'toxicity',
                        'light',
                        'cultivars',
                ]
            }
        },
        created: function () {
            this.id = this.$route.params.id;
            this.getInfo(this.id);

            
        },
        methods: {
            getInfo: async function () {
                let self = this;
                let token = localStorage.getItem('token');

                const {data} = await axios.get(
                    `${this.$hostname}/admin/plants/${self.id}`,
                    {
                        'headers': {
                            'Authorization':  token
                        }
                    });

                
                self.data = data;
                document.title = `${data.botanical_name}`;
            },
            
            isJson: function (str) {
                try {
                    JSON.parse(str);
                } catch (e) {
                    return false;
                }

                return true;
            },

            removePhotoImageItem: function (imgIndex) {
                this.data.photos.splice(imgIndex, 1);
            },
            save: async function () {
                let self = this;

                this.$loading.show({delay:0});

                axios.post(
                    `${this.$hostname}/admin/plants/${self.id}/save`,
                    {
                        id: this.data.id,
                        preview_img: this.data.preview_img,
                        photos: this.data.photos,
                        type: 'photo'
                    },
                    {
                        'headers': {
                            'Authorization': self.token
                        }
                    })
                    .then(function (response) {

                        const notification = {
                            template: `<span><b>Info saved</b></span>`
                        };

                        self.$notifications.notify(
                            {
                                component: notification,
                                icon: 'nc-icon nc-explore-2',
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'info'
                            });

                    })
                    .catch(function (error) {
                        const notification = {
                            template: `<span><b>${error.response.data.message}</b></span>`
                        };

                        self.$notifications.notify(
                            {
                                component: notification,
                                icon: 'nc-icon nc-simple-remove',
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'danger'
                            })
                    })
                    .finally(function () {
                        self.$loading.hide()
                    });
            },
            uploadFile: function (event) {
                let self = this;

                let formData = new FormData();

                formData.append('file', event.target.files[0]);

                this.$loading.show({delay:0});

                axios.post(
                    `${this.$hostname}/admin/services/photo/upload`,
                    formData,
                    {
                        headers: {
                            'Authorization': self.token,
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                ).then(function ({data}) {
                    self.data.preview_img = data.url;
                })
                .catch(function (error) {
                    console.log(error);
                    const notification = {
                            template: `<span><b>Error uploading.</b></span>`
                        };

                        self.$notifications.notify(
                            {
                                component: notification,
                                icon: 'nc-icon nc-simple-remove',
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'danger'
                            })
                })
                .finally(function () {
                    self.$loading.hide()
                })
            },

            
        }
    }

</script>
<style scoped>
    .property-label {
        font-size: 15px;
        color: black;
        font-weight: bold;
    }
    button:disabled,
    button[disabled] {
        cursor: not-allowed;
    }

    .btn-save {
        width: 150px;
    }

    .col-md-4 {
        padding: 15px !important;
    }

    .checkbox-block {
        margin-top: 40px;
        margin-left: 40px;
    }

    .btn-file {
        display: none;
    }

    .image-block {
        max-width: 100%;
    }

    .form-check-inline {
        display: inline-block;
    }

    .label-checkbox {
        margin-right: 10px
    }

    .link {
        cursor: pointer;
        text-decoration: underline;
    }
    .card-body p {
        font-weight: 300;
        font-style: italic;
    }

    .card-body form {
        /*margin-top: 15px;*/
    }

    /* Customize the label (the container) */
    .container {
        display: block;
        position: relative;
        padding-left: 30px;
        margin-bottom: 12px;
        cursor: pointer;
        font-size: 12px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    /* Hide the browser's default checkbox */
    .container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    /* Create a custom checkbox */
    .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 20px;
        width: 20px;
        background-color: #ccc;
    }

    /* On mouse-over, add a grey background color */
    .container:hover input ~ .checkmark {
        opacity: 0.8;
    }

    /* When the checkbox is checked, add a blue background */
    .container input:checked ~ .checkmark {
        background-color: #54abfe;
    }

    /* Create the checkmark/indicator (hidden when not checked) */
    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    /* Show the checkmark when checked */
    .container input:checked ~ .checkmark:after {
        display: block;
    }

    /* Style the checkmark/indicator */
    .container .checkmark:after {
        left: 8px;
        top: 4px;
        width: 5px;
        height: 10px;
        border: solid #fff;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }
    .preview-device {
        display: inline-block;
        width: 32%;
        margin-left: 10px;
    }
    .device-block {
        position: relative;
        background-position: center center;
        background-size: cover;
        cursor: pointer;
    }
    .device-block.inactive {
        opacity: 0.5;
    }
    .device-block span {
        position: absolute;
        top: -30px;
        left: 5px;
    }
    .device-block img {
        width: 40px;
        height: 40px;
        position: absolute;
        right: 18px;
        top: 18px;
    }
    .device1 {
        display: inline-block;
        /*width: 281px;*/
        /*height: 609px;*/
        width: 337px;
        height: 731px;
        border: 3px solid #000;
        border-radius: 10px;
        margin-left: 40px;
    }
    .device2 {
        display: inline-block;
        /*width: 310px;*/
        /*height: 552px;*/
        width: 372px;
        height: 662px;
        border: 3px solid #000;
        border-radius: 10px;
        margin-left: 50px;
    }
    .device3 {
        display: inline-block;
        /*width: 384px;*/
        /*height: 512px;*/
        width: 461px;
        height: 614px;
        border: 3px solid #000;
        border-radius: 10px;
        margin-left: 50px;
    }
    .mt30 {
        margin-top: 30px;
    }
    .p-photo {
        max-width: 100%;
        margin-bottom: 20px;
    }
    .images-col {
        max-width: 100%;
        margin-bottom: 20px;
    }
    .images-row {
       border: 1px solid #E3E3E3;
        margin: 1px;
        padding: 20px;
        /* display: block;  */
    }
    .img-item {
        /* элемент тени */
        cursor: pointer;
        -webkit-box-shadow: 0 5px 2px -3px rgba(0, 0, 0, 0.1), 0 1px 0px rgba(0, 0, 0, 0.1);
        -moz-box-shadow: 0 5px 2px -3px rgba(0, 0, 0, 0.1), 0 1px 0px rgba(0, 0, 0, 0.1);
        box-shadow: 0 5px 2px -3px rgba(0, 0, 0, 0.1), 0 1px 0px rgba(0, 0, 0, 0.1); 
    }
    .img-item:hover { 
        /* элемент тени если наведен курсор */ 
        -webkit-box-shadow: 0 15px 10px -10px rgba(0, 0, 0, 0.5), 0 1px 0px rgba(0, 0, 0, 0.3); 
        -moz-box-shadow: 0 15px 10px -10px rgba(0, 0, 0, 0.5), 0 1px 0px rgba(0, 0, 0, 0.3); 
        box-shadow: 0 15px 10px -10px rgba(0, 0, 0, 0.3), 0 1px 0px rgba(0, 0, 0, 0.1); 
        /* элемент тени если наведен курсор конец */ 
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Plants/PlantPhoto.vue